import { useState } from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import { Navbar } from "@/components/Navbar";
import { Hero } from "@/components/Hero";
import { Welcome } from "@/components/Welcome";
import { Rooms } from "@/components/Rooms";
import { Gallery } from "@/components/Gallery";
import { Reviews } from "@/components/Reviews";
import { ReservationForm } from "@/components/ReservationForm";
import { Footer } from "@/components/Footer";
import { WhatsAppButton } from "@/components/WhatsAppButton";
import AdminLogin from "@/pages/AdminLogin";
import AdminDashboard from "@/pages/AdminDashboard";

const Home = () => {
  const [selectedRoom, setSelectedRoom] = useState("");

  return (
    <div data-testid="home-page">
      <Navbar />
      <main>
        <Hero />
        <Welcome />
        <Rooms onBookRoom={setSelectedRoom} />
        <Gallery />
        <Reviews />
        <ReservationForm selectedRoom={selectedRoom} />
      </main>
      <Footer />
      <WhatsAppButton />
    </div>
  );
};

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/admin/login" element={<AdminLogin />} />
          <Route path="/admin" element={<AdminDashboard />} />
        </Routes>
      </BrowserRouter>
      <Toaster position="top-center" richColors />
    </div>
  );
}

export default App;
